/**
 * Formats seconds into MM:SS format with zero-padding
 * @param seconds - Number of seconds to format
 * @returns Formatted string in MM:SS format (e.g., "01:30")
 */
export const formatSecondsToMMSS = (seconds: number): string => {
  const mm = Math.floor(seconds / 60);
  const ss = seconds % 60;
  return `${mm.toString().padStart(2, "0")}:${ss.toString().padStart(2, "0")}`;
};

/**
 * Calculates progress percentage (0-100) based on remaining and initial seconds
 * @param secondsLeft - Number of seconds remaining
 * @param initialSeconds - Total initial seconds
 * @returns Progress as percentage (0-100)
 */
export const calculateTimerProgress = (
  secondsLeft: number,
  initialSeconds: number
): number => {
  if (initialSeconds <= 0) return 0;
  return (1 - secondsLeft / initialSeconds) * 100;
};
